export default {
  loadMigrationsSuccess: ({ migrations }, payload) => {
    migrations.pagination.totalItems = payload.recordsTotal;
    migrations.items = payload.data;
  },
  setPagination({ migrations }, payload) {
    migrations.pagination = payload;
  },
  deleteMigration: ({ migrations }, payload) => {
    migrations.items = migrations.items.filter(function (item) {
      return item.id !== payload.id;
    });
  },
};
